import { v7 as uuidv7 } from "uuid";
import { z } from "zod";
import { companySchema } from "./company";

export const buildingSchema = z.object({
  id: z.string().brand("buildingId"),
  casNaviId: z.number(),
  name: z.string(),
  nameKana: z.string(),
  nameNayose: z.string().optional().nullish(),
  postalCode: z.string(),
  address: z.string(),
  companyId: companySchema.shape.id,
  isSuitsNeeded: z.boolean().default(false),
  needDisasterCenter: z.boolean().default(false),
  mustCleaning: z.boolean().default(false),
  menOnly: z.boolean().default(false),
  womenOnly: z.boolean().default(false),
  createdAt: z
    .string()
    .or(z.date())
    .transform((val) => (typeof val === "string" ? val : val.toISOString())),
  updatedAt: z
    .string()
    .or(z.date())
    .transform((val) => (typeof val === "string" ? val : val.toISOString())),
});

export const editBuildingSchema = buildingSchema.pick({
  nameNayose: true,
  isSuitsNeeded: true,
  mustCleaning: true,
  menOnly: true,
  womenOnly: true,
  needDisasterCenter: true,
});

export type Building = z.infer<typeof buildingSchema>;
export type BuildingInput = z.input<typeof buildingSchema>;
export type EditBuildingInput = z.input<typeof editBuildingSchema>;

// 会社情報を含む建物型
export const buildingWithCompanySchema = buildingSchema.extend({
  companyName: z.string(),
});
export type BuildingWithCompany = z.infer<typeof buildingWithCompanySchema>;

export const newBuilding = (input: BuildingInput): Building => buildingSchema.parse(input);
export const createBuilding = (input: Omit<BuildingInput, "id">): Building => newBuilding({ ...input, id: uuidv7() });
export const editBuilding = (input: EditBuildingInput): EditBuildingInput => editBuildingSchema.parse(input);
